import React, { useState } from "react";
import "../../../components/FilterDrawer/filterDrawer.scss";
import {
  Box,
  Button,
  Drawer,
  Grid,
  TextField,
  Typography,
} from "@mui/material";

import { cross_default_icon } from "../../../constants/icons";

import IconButtons from "../../../components/IconButtons/IconButtons";
import Loader from "../../../components/Loader/Loader";
import SimpleAutoComplete from "../../../components/SimpleAutoComplete/SimpleAutoComplete";
import DateTimePickerComponent from "../../../components/DateTimePickerComponent/DateTimePickerComponent";
import { font_15 } from "../../../utils/utils";

const MyFormFilterDrawer = ({
  open,
  onClose,
  handleFilterChange,
  handleFilterRemove,
  handleFilterSubmit,
  filterValue,
  modalApiLoad,
  formNameOptions = [],
  statusOptions = [],
  hideStatusSelect = false,
  showTriggerFilter = false
}) => {
  const [loader, setLoader] = useState(false);

  const handleFilter = async () => {
    setLoader(true);
    await handleFilterSubmit();
    setLoader(false);
  };

  if (loader) {
    return <Loader />;
  }
  const formatDate = (date) => {
    if (!date) return "-";
    const parsedDate = new Date(date);
    if (isNaN(parsedDate.getTime())) return "-";

    return parsedDate.toLocaleDateString("en-IN", {
      day: "2-digit",
      month: "short",
      year: "numeric",
      timeZone: "UTC",
    });
  };
  const renderTriggerFields = () => {
    if (!showTriggerFilter) return null;
    if (filterValue?.formName?.triggers?.length > 0) {
      return (
        <SimpleAutoComplete
          label="Select Period / Assessment"
          placeholder="Select Trigger"
          options={(filterValue?.formName?.triggers || []).map((t) => ({
            ...t,
            displayName:
              filterValue?.formName?.type === "CLASSROOM_ASSESSMENT_PERFORMANCE"
                ? `${t.assessmentName || "Assessment"} (${formatDate(t.assessmentDate)})`
                : `${formatDate(t.periodFrom)} - ${formatDate(t.periodTo)}`,
          }))}
          value={filterValue?.trigger || null}
          onChange={(event, newValue) => handleFilterChange("trigger", newValue)}
          getOptionLabel={(option) => option?.displayName || ""}
          renderOption={(props, option) => (
            <li
              {...props}
              key={option.id}
              className={
                option?.id === filterValue?.trigger?.id
                  ? "multi-tag-edit-list-selected"
                  : "multi-tag-style"
              }
            >
              <Box>{option?.displayName}</Box>
            </li>
          )}
        />
      );
    }
    return null;
  };

  return (
    <>
      {modalApiLoad && <Loader />}
      <Drawer
        className="filter-drawer-container"
        anchor="right"
        open={open}
        onClose={onClose}
      >
        <Grid container className="filter-main-container">
          <Grid item md={12} pt={2} className="drawer-input-container">
            <Box className="filter-head">
              <Typography variant="font_20" className="filter-title">
                Filters
              </Typography>
              <IconButtons
                handleClick={onClose}
                height={font_15}
                width={font_15}
                image={cross_default_icon}
                tooltip="Close Filter"
              />
            </Box>
            <Box className="filter-padding textfield-box">
              <SimpleAutoComplete
                label="Form Name"
                placeholder="Select Form"
                options={formNameOptions}
                value={filterValue?.formName}
                onChange={(event, newValue) =>
                  handleFilterChange("formName", newValue)
                }
                getOptionLabel={(option) => option?.name || ""}
                renderOption={(props, option) => (
                  <li
                    {...props}
                    key={props.id}
                    className={
                      option?.id === filterValue?.formName?.id
                        ? "multi-tag-edit-list-selected"
                        : "multi-tag-style"
                    }
                  >
                    <Box>{option?.name}</Box>
                  </li>
                )}
              />

              {!hideStatusSelect && (
                <SimpleAutoComplete
                  label="Status"
                  placeholder="Select Status"
                  options={statusOptions}
                  value={filterValue?.status}
                  onChange={(event, newValue) =>
                    handleFilterChange("status", newValue)
                  }
                  getOptionLabel={(option) => option?.name || ""}
                  renderOption={(props, option) => (
                    <li
                      {...props}
                      key={props.id}
                      className={
                        option?.id === filterValue?.status?.id
                          ? "multi-tag-edit-list-selected"
                          : "multi-tag-style"
                      }
                    >
                      <Box>{option?.name}</Box>
                    </li>
                  )}
                />
              )}
              {renderTriggerFields()}
            </Box>
          </Grid>

          <Grid item md={12} className="filter-padding filter-btn-container">
            <Button
              onClick={handleFilter}
              variant="contained"
              color="secondary"
              className="block-button filter-btn margin-right-1"
            >
              <Typography variant="outlineBtnLabel">
                Apply Filters
              </Typography>
            </Button>
            <Button
              onClick={handleFilterRemove}
              variant="outlined"
              color="secondary"
              className="block-button filter-btn"
            >
              <Typography variant="outlineBtnLabel">
                Reset
              </Typography>
            </Button>
          </Grid>
        </Grid>
      </Drawer>
    </>
  );
};

export default MyFormFilterDrawer;
